import { Box } from "@prismicio/editor-ui"
import type { PropsWithChildren } from "react"

export function UsagePageTabContentGrid(props: PropsWithChildren) {
  return (
    <Box {...props} display="grid" gap={24} gridTemplateColumns="2fr 1fr" />
  )
}
